import { HTMLAttributes } from 'react'

import { Drawer, DrawerProps, Heading } from '@hhgtech/hhg-components'
import { useIntl } from 'react-intl'

import { useIsMobile } from 'hooks/useIsMobile'
import { CategoryApi } from 'interfaces/types'

import { Category } from './category'
import { StyledPregnancyNavigation } from './index.styled'

type PregnancyNavigationProps = {
  categories: Array<CategoryApi>
  drawerProps?: DrawerProps
} & HTMLAttributes<HTMLDivElement>

const PregnancyNavigationDrawer = ({
  categories,
  drawerProps,
}: PregnancyNavigationProps) => {
  const { formatMessage: f } = useIntl()
  if (!drawerProps) return null
  const { open, ...rest } = drawerProps
  return (
    <Drawer
      title={f({
        id: 'pregnancyTool.pregnancyNavigation.title',
        defaultMessage: 'Pregnancy Navigation',
      })}
      open={open}
      placement="bottom"
      {...rest}
    >
      <div>
        {categories.map((cat) => (
          <Category key={cat.term_id} category={cat} />
        ))}
      </div>
    </Drawer>
  )
}

export const PregnancyNavigation = ({
  categories,
  drawerProps,
  ...rest
}: PregnancyNavigationProps) => {
  const { formatMessage: f } = useIntl()
  const isMobile = useIsMobile()

  if (!categories || categories?.length === 0) return null
  if (isMobile)
    return (
      <PregnancyNavigationDrawer
        categories={categories}
        drawerProps={drawerProps}
      />
    )
  return (
    <StyledPregnancyNavigation {...rest}>
      <Heading tag="h4" fontWeight="bold">
        {f({
          id: 'pregnancyTool.pregnancyNavigation.title',
          defaultMessage: 'Pregnancy Navigation',
        })}
      </Heading>
      <div className="category-wrapper">
        {categories.map((cat) => (
          <Category key={cat.term_id} category={cat} />
        ))}
      </div>
    </StyledPregnancyNavigation>
  )
}
